module.exports = __webpack_public_path__ + "img/fonts-button.64c7b9b1.svg";